import { httpClient } from "api/httpClient";
import { useCallback, useEffect, useRef } from "react";

export const isAbortError = (error) => error?.name === "AbortError";

export const isTimeoutError = (error) => error?.isTimeout === true;

const timeoutError = () => Object.assign(new Error("request timed out"), { isTimeout: true });

export const useAbortableRequest = () => {
	const controllersRef = useRef(new Set());

	useEffect(() => {
		const controllers = controllersRef.current;
		return () => {
			controllers.forEach((controller) => controller.abort());
			controllers.clear();
		};
	}, []);

	return useCallback(async (url, { timeoutMs, ...options } = {}) => {
		const controller = new AbortController();
		const controllers = controllersRef.current;
		controllers.add(controller);

		let hasTimedOut = false;
		const timer = timeoutMs
			? setTimeout(() => {
					hasTimedOut = true;
					controller.abort();
				}, timeoutMs)
			: null;

		try {
			return await httpClient(url, { ...options, signal: controller.signal });
		} catch (error) {
			throw hasTimedOut ? timeoutError() : error;
		} finally {
			if (timer) clearTimeout(timer);
			controllers.delete(controller);
		}
	}, []);
};
